$('.faqs__item__caption').on('click', function () {
    const $button = $(this);
    const $item = $(this).closest('.faqs__item');
    const $content = $item.find('.faqs__item__content');
    $('.faqs__item__caption').not($button).removeClass('active');
    $('.faqs__item__content').not($content).slideUp();
    $button.toggleClass('active');
    $content.slideToggle();
});